import slides from './slides';
const numberOfQuestions = 7;

// get random questions
export function getInitialQuestions(questions){
  return questions
    .concat()
    .sort( () => 0.5 - Math.random() )
    .slice(0, numberOfQuestions)
};

export const initialChoices = [
  {
    slug: 'holiday-riches',
    count: 0,
    weight: 1,
  },
  {
    slug: 'seasons-winnings',
    count: 0,
    weight: 2,
  },
  {
    slug: 'festive-50',
    count: 0,
    weight: 3,
  },
  {
    slug: 'sneak-a-peak',
    count: 0,
    weight: 4,
  },
  {
    slug: 'raffle',
    count: 0,
    weight: 5,
  },
  {
    slug: 'tacky-sweater',
    count: 0,
    weight: 6,
  },
  // {
  //   slug: 'chia-cash',
  //   count: 0,
  //   weight: 7,
  // },
  // {
  //   slug: '20-years-of-cash',
  //   count: 0,
  //   weight: 8,
  // },
  // {
  //   slug: '100x-the-money',
  //   count: 0,
  //   weight: 9,
  // },
];

const initialState = {
  view: 'intro',
  previousView: '',
  scratcherDetail: '',
  scratcherPosition: 1,
  personality: [],
  numberOfQuestions: numberOfQuestions,
  scratcherChoice: initialChoices,
  questions: getInitialQuestions(slides),
  faqDropdown: 'none',
  calculatingResults: false,
  isPlaying: true,
  userId: '',
  sessionId: '',
};

export default initialState;



/** WEBPACK FOOTER **
 ** ./src/initialState.js
 **/